import { fmtDateTime, fmtMoney } from './format'
import type { FromEmail, Step } from '../api/visitors'

export const STEP_LABEL: Record<Step, string> = {
  visit: 'Visits', engaged: 'Engaged', considered: 'Considered', checkout: 'Checkout started', paid: 'Paid',
}
export const cents = (n: number) => fmtMoney(n / 100)
export const rate = (x: number) => `${Math.round(x * 1000) / 10}%`
export function duration(ms: number): string {
  const s = Math.round(ms / 1000)
  return s >= 60 ? `${Math.floor(s / 60)}m ${s % 60}s` : `${s}s`
}
export function delta(cur: number, prev: number): { text: string; tone: 'green' | 'red' | 'faint' } {
  if (prev === 0) return cur > 0 ? { text: 'new', tone: 'faint' } : { text: '—', tone: 'faint' }
  const p = Math.round(((cur - prev) / prev) * 100)
  if (p === 0) return { text: '0%', tone: 'faint' }
  return p > 0 ? { text: `▲ ${p}%`, tone: 'green' } : { text: `▼ ${Math.abs(p)}%`, tone: 'red' }
}

/** "<subject> · <send_type> · <sent_at>"; without member access the server sends only the kind of email. */
export function fromEmailLine(f: FromEmail): string {
  return [f.subject, f.send_type, f.sent_at ? fmtDateTime(f.sent_at) : null].filter(Boolean).join(' · ')
}

export function errorDetail(e: unknown): string {
  const d = (e as { detail?: unknown } | null)?.detail
  if (typeof d === 'string') return d
  if (d && typeof d === 'object') {
    const inner = (d as { detail?: unknown }).detail
    if (typeof inner === 'string') return inner
    if (Array.isArray(inner)) return inner.map((x) => (x as { msg?: string }).msg ?? JSON.stringify(x)).join('; ')
    return JSON.stringify(d)
  }
  return e instanceof Error ? e.message : 'Request failed'
}
